var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4914 13.4914C6.59481 20.388 6.59481 31.5825 13.4914 38.4792C20.388 45.3758 31.5826 45.3758 38.4792 38.4792C45.3758 31.5825 45.3758 20.388 38.4792 13.4914C31.5826 6.5948 20.388 6.5948 13.4914 13.4914ZM33.4816 20.9877L28.4841 25.9853L33.4816 30.9828L30.9828 33.4816L25.9853 28.4841L20.9878 33.4816L18.489 30.9828L23.4865 25.9853L18.489 20.9877L20.9878 18.489L25.9853 23.4865L30.9828 18.489L33.4816 20.9877Z",
    fill: "#ED6565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.010d24e4d5979553f4632611851af5e3.svg";
export { ForwardRef as ReactComponent };